<template>
  <div
    class="px-2 py-4 b rounded-xs bg-grey-90 flex gap-2 relative"
    :class="modelValue === type ? 'b-grey-10' : 'b-transparent'"
  >
    <vf-icon class="row-span-2" :name="icon" size="md" />
    <span class="text-sm f-col gap-1">
      <base-radio
        v-model="modelValue"
        :aria-describedby="[type === 'pickup' ? 'pickup-store' : '', `${type}-description`].join(' ')"
        :value="type"
        @change="$emit('change', $event)"
      >
        <span class="fw-medium peer-focus-visible:outline-auto">
          {{ label }}
        </span>
        <span class="cursor-pointer absolute-0" />
      </base-radio>
      <span v-if="type === 'standard'" id="standard-description" class="f-col gap-1 fw-light">
        <span>
          {{ $t.standardShipping }}
        </span>
        <span v-if="description">
          {{ description }}
        </span>
      </span>
      <template v-else-if="type === 'pickup'">
        <span v-if="selectedStore" id="pickup-store" class="fw-light">
          {{ selectedStore.name }}
        </span>
        <base-button class="py-px underlined self-start relative z-1" @click="$emit('open-search')">
          {{ selectedStore ? $t.changeStore.title : $t.findStore }}
        </base-button>
        <span v-if="description" id="pickup-description" class="fw-light" :class="{ 'c-red-30': error }">
          {{ description }}.
        </span>
      </template>
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { LocatorSearchItem } from '#types/brandify'
import type { IconName } from '#types/icon'

defineProps<{
  type: 'standard' | 'pickup'
  label: string
  icon?: IconName
  description?: string
  selectedStore?: LocatorSearchItem
  error?: boolean
}>()

defineEmits<{
  'change': [value: string]
  'open-search': []
}>()

const modelValue = defineModel<string>()
</script>
